import MenuItem from '@mui/material/MenuItem'
import {FC} from 'react'
import {TokenType} from 'entities/payment'
import {CardNoContainer} from 'features/cardItem'
import {Select} from 'shared/ui/select'
import './styles.scss'

type CardSelectProps = {
  tokens: TokenType[]
  value: string
  onChange: (token: string) => void
}

export const CardSelect: FC<CardSelectProps> = ({tokens, value, onChange}) => {
  return (
    <Select
      value={value}
      onChange={(event) => onChange(event.target.value as string)}
    >
      {tokens.map((item) => (
        <MenuItem value={item.id} key={item.id}>
          <CardNoContainer wrap {...item} />
        </MenuItem>
      ))}
    </Select>
  )
}
